import staticConfig from './server/config.json';
import dynamicConfig from './aws-config.json';

export type Config = StaticConfig & {
    namePrefix: string;
    s3Bucket: string;
    secretName: string;
    userPoolClientId: string;
    userPoolId: string;
};

enum Environment {
    PRODUCTION = 'production',
    DEVELOP = 'develop',
}

const DeploymentPrefix = {
    [Environment.PRODUCTION]: 'PptAi' as const,
    [Environment.DEVELOP]: 'PptAiDev' as const,
} satisfies Record<Environment, string>;

type StaticConfig = Omit<typeof staticConfig, 'deployment'> & {
    deployment: typeof staticConfig['deployment'][Environment];
};

function getStage() {
    const env = process.env.DEPLOYMENT_ENVIRONMENT;
    if (env === 'develop') {
        return Environment.DEVELOP;
    }
    return Environment.PRODUCTION;
}

export function getConfig<
    Prefix extends typeof DeploymentPrefix[Environment] = 'PptAi'
>(): Config {
    const env = getStage();
    const prefix = DeploymentPrefix[getStage()] as Prefix;
    const { deployment, ...conf } = staticConfig;
    return {
        ...conf,
        deployment: deployment[env],
        namePrefix: prefix,
        s3Bucket:
            // @ts-expect-error -- yeah yeah
            dynamicConfig[`${prefix}BucketStack`]?.[`${prefix}bucketName`] ??
            '',
        secretName:
            // @ts-expect-error -- yeah yeah
            dynamicConfig[`${prefix}SecretStack`]?.[`${prefix}secretName`] ??
            '',
        userPoolClientId:
            // @ts-expect-error -- yeah yeah
            dynamicConfig[`${prefix}UserPoolStack`]?.[
                `${prefix}userPoolClientId`
            ] ?? '',
        userPoolId:
            // @ts-expect-error -- yeah yeah
            dynamicConfig[`${prefix}UserPoolStack`]?.[`${prefix}userPoolId`] ??
            '',
    };
}
